export default __webpack_public_path__ + "c451fdc294a4e7d3a906d5da6df88b2d.png";